import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, Plus, Scale } from "lucide-react";
import AppLayout from "../components/AppLayout";
import SavOpenDialog from "../components/sav/SavOpenDialog";
import { api } from "../lib/api";

export default function LitigesPage() {
  const [items, setItems] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => { api.get("/sav", { params: { limit: 2000 } }).then((r) => setItems(r.data.items.filter((s) => s.kind === "litige"))).catch(() => setItems([])); }, []);
  return (
    <AppLayout>
      <div className="space-y-5" data-testid="litiges-page">
        <div className="flex items-end justify-between gap-4">
          <div><div className="text-xs text-norea-textMuted">Service Après-Vente</div>
            <h1 className="font-heading text-3xl font-medium flex items-center gap-2"><Scale className="w-6 h-6 text-norea-primary" />Litiges</h1></div>
          <button onClick={() => setOpen(true)} className="btn-primary text-sm" data-testid="litige-new-btn"><Plus className="w-4 h-4" /> Nouveau litige</button>
        </div>
        {!items ? <Loader2 className="w-5 h-5 animate-spin" /> : items.length === 0 ? <div className="card-flat p-8 text-sm text-norea-textMuted" data-testid="litiges-empty">Aucun litige ouvert.</div> : (
          <table className="w-full text-sm bg-white border border-norea-border rounded-md" data-testid="litiges-table">
            <thead><tr className="text-left text-xs text-norea-textMuted border-b border-norea-border">
              <th className="p-2">Référence</th><th className="p-2">Client</th><th className="p-2">Motif</th><th className="p-2">Avocat</th><th className="p-2">Statut</th><th className="p-2">Ouvert le</th></tr></thead>
            <tbody>{items.map((s) => (
              <tr key={s.id} className="border-b border-norea-border hover:bg-norea-surfaceHover" data-testid={`litige-row-${s.id}`}>
                <td className="p-2"><Link to={`/sav/${s.id}`} className="font-medium text-norea-primary hover:underline">{s.reference}</Link></td>
                <td className="p-2">{[s.client?.prenom, s.client?.nom].filter(Boolean).join(" ")}</td>
                <td className="p-2">{s.values?.motif || "—"}</td><td className="p-2">{s.avocat_id ? "Oui" : "—"}</td>
                <td className="p-2">{s.status_label}</td><td className="p-2">{new Date(s.created_at).toLocaleDateString("fr-FR")}</td>
              </tr>))}</tbody>
          </table>
        )}
      </div>
      {open && <SavOpenDialog initialKind="litige" onClose={() => setOpen(false)} />}
    </AppLayout>
  );
}
